import 'bootstrap'
import 'slick-carousel'
import IE_SRCSET from '../plugins/polyfill-ie-srcset'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, l ] = [ window, document, location ]

const recruitSlider = {
  obj:'[data-plugin="recruitslider"]',
  animationDuration: 8000,
  init() {
    $(this.obj).slick({
      autoplay:true,
      fade: true,
      dots: true,
      speed: 2000,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
    $(this.obj).on('beforeChange', (e, slick, cs, ns) => {
      $(`[data-slick-index=${ns}]`).addClass('is-animation-start')
      setTimeout(() => $(`[data-slick-index=${ns}]`).removeClass('is-animation-start'),
        this.animationDuration
      )
    })
  },
  start() {
    $(this.obj).slick('slickPlay').addClass('is-slickPlay')
    $(`[data-slick-index=0]`).addClass('is-animation-start')
    setTimeout(() => $(`[data-slick-index=0]`).removeClass('is-animation-start'),
      this.animationDuration
    )
  }
}


const init = () => {
  // bootstrapのcss読み込み
  w.addStylesheet({ href: "/asset/css/bootstrap.min.css" })

  $.when( w.load['recruit'] ).then( () => {
    // slick実行
    recruitSlider.init(), recruitSlider.start()

    //ticker
    let makeItem = item => $(`
      <a href="${item.href}" class="link" target="_blank">
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.recruit-ticker__article[data-plugin="getArticles"]', { makeItem })

    $('.ExplainSSL__wrapper').on('click', function() {
      console.log('test')
      $('#ExplainSSL').toggleClass('open')
    })
  })

  // slot適用
  $.when( w.load['recruit-entry'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="recruit-entry__banner"]' )
    slot ? $obj.replaceWith( slot ) : $obj.hide()
  })
  $.when( w.load['recruit-interview'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="recruit-entry__interview"]' )
    $obj.each( (i,item) => {
      let area = item.dataset.area
      let data = slot ? $(slot).find(`[data-area="${area}"]`) : null
      return data ? $(item).empty().append( data ) : false
    })
  })

}

export default function RECRUIT() {
  IE_SRCSET()
  $( init )
}